module.exports = __webpack_public_path__ + "ClinicaPro-Regular-webfont.1ffce73c1056936b6d41.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/ClinicaPro-Regular-webfont.woff2
// module id = ../../../../../src/assets/fonts/ClinicaPro-Regular-webfont.woff2
// module chunks = styles